import { useState, useEffect, useRef } from 'react';
import { Carousel } from 'react-bootstrap';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import BirdseyModal from './BirdseyModal';
import { trackButtonClick } from '@/utils/analytics';

const Advertisment = ({ adsData, propertyId }) => {
  const ads = adsData || [];
  const [index, setIndex] = useState(0);
  const [showBanner, setShowBanner] = useState(false);
  const intervalRef = useRef(null);

  const handleSelect = ({url, selectedIndex, name}) => {
    if (selectedIndex === 3) {
      setShowBanner(true);
    } else {
      window.open(url, '_blank');
    }
    setIndex(selectedIndex);
    trackButtonClick({
      eventName: "carousel_ad_click",
      eventCategory: "NEW-PDP",
      eventSource: "on ad clcik",
      eventLabel: `Advertiser: ${name} | Carousel Ad Position:${selectedIndex + 1}`
    })
  };

  const handlePrev = () => {
    setIndex((prevIndex) => (prevIndex === 0 ? ads.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setIndex((prevIndex) => (prevIndex === ads.length - 1 ? 0 : prevIndex + 1));
  };

  // Autoplay using useRef
  useEffect(() => {
    if (ads.length === 0) return;

    intervalRef.current = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % ads.length);
    }, 5000); // 5 seconds

    return () => clearInterval(intervalRef.current);
  }, [ads.length]);

  return (
    <div className="left_side_widget" style={{ position: 'relative' }}>
      <Carousel
        activeIndex={index}
        controls={false}
        indicators={false}
        interval={null}
        style={{ height: 'auto' }}
      >
        {ads.map((item, idx) => (

          <Carousel.Item key={idx} onClick={() => handleSelect({url: item?.actionURL, selectedIndex: idx, name: item?.name})}>
             {/* <span id="ad" className="pdpAd">Ad</span> */}
             <span id="ad" className="pdpAd" style={{ position: 'absolute', top: '15px', right: '10%', zIndex: 4, backgroundColor: '#59946b', color: 'white', padding: '2px 6px', fontSize: '12px', borderRadius: '2px' }}>Ad</span>
            <img
              style={{paddingLeft:40, paddingTop:5, paddingBottom:5,  height: '80%', width: '90%', cursor: 'pointer' }}
              src={item.backgroundImageUrl}
              alt={`Slide ${idx + 1}`}
            />
          </Carousel.Item>
        ))}
      </Carousel>

      {/* Custom Arrows */}
      {
        ads?.length > 1 &&
         <><button aria-label="left" onClick={handlePrev} style={arrowStyle('left')}>
          <MdKeyboardArrowLeft />
        </button><button aria-label="right" onClick={handleNext} style={arrowStyle('right')}>
            <MdKeyboardArrowRight />
          </button></>
      }
      <BirdseyModal showBanner={showBanner} setShowBanner={setShowBanner} propertyId={propertyId} />
    </div>
  );
};

const arrowStyle = (side) => ({
  position: 'absolute',
  top: '50%',
  [side]: '10px',
  transform: 'translateY(-50%)',
  background: 'rgba(0,0,0,0.5)',
  color: 'white',
  border: 'none',
  borderRadius: '50%',
  width: '40px',
  height: '40px',
  zIndex: 4,
});

export default Advertisment;
